import {
  FilterMode,
  TadManagerConfig_OrderBy,
  TadManagerConfig,
  SortOrder,
  TadManagerConfig_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const tadManagerConfigService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tadManagerConfigOne({ id });
    return result.tadManagerConfigOne as TadManagerConfig;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TadManagerConfig_OrderBy[] | null = null,
    filter: TadManagerConfig_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TadManagerConfig_Filter | undefined;
    if (searchValue !== "") {
      where = {
        idCard: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tadManagerConfigListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ idCard: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tadManagerConfigListWithOffset
    ) as TadManagerConfig[];
    return { list, orderBy };
  },
};
